
import { useState } from "react";
import { Trial } from "@/types/trials";

export const useTrials = () => {
  const [trials, setTrials] = useState<Trial[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [searchQuery, setSearchQuery] = useState("");
  
  // Stub implementation that doesn't try to access Supabase
  const fetchTrials = async () => {
    setIsLoading(true);
    try {
      // This is just a stub - no actual database calls
      // We could add mock data here if needed:
      // const mockTrials: Trial[] = [
      //   {
      //     id: "1",
      //     lead_id: "1",
      //     plan: "pro",
      //     started_at: new Date().toISOString(),
      //     expires_at: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString(),
      //   }
      // ];
      // setTrials(mockTrials);
      setTrials([]);
    } catch (err) {
      console.error("Error fetching trials:", err);
      setError("Erro ao carregar test drives");
    } finally {
      setIsLoading(false);
    }
  };
  
  const refresh = () => {
    fetchTrials();
  };
  
  return {
    trials,
    isLoading,
    error,
    searchQuery,
    setSearchQuery,
    refresh,
  };
};
